export const state = {
  filter: 'Muscles',
  filterValue: '',
  pagination: null,
};
